module.exports = __webpack_public_path__ + "img/start.42a1e1a4.svg";